import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagLC = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F3F3F3",
  d: "M15.762 33.696H34.24L25 11.956l-9.238 21.74Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#333536",
  d: "M18.97 31.522 25 17.81l6.028 13.712H18.971Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M15.762 33.696H34.24L25 25l-9.238 8.696Z"
}));
FlagLC.displayName = 'FlagLC';
export default withFlagWrapper(FlagLC);
//# sourceMappingURL=index.js.map